export default {
    'hallh.loading': 'Loading',
    'hallh.primary.title': 'Latihan',
    'hallh.middle.title': 'Ahli',
    'hallh.high.title': 'Elit',
    'hallh.top.title': 'Menguasai',
    'hallh.level.describe': 'Kondisi Hall',
    'hallh.coin.not': 'Koin Tidak Cukup',
    'hallh.setting.title': 'Pengaturan',
};